import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-account',
    templateUrl: './alert-account.component.html',
    styleUrls: ['./alert-account.component.scss']
})
export class AlertAccountComponent {
    public constructor(private closeAlertAccountComponent: MatDialogRef<AlertAccountComponent>) {}

    public closeCreateAccountDialog(activateAccount: boolean): void {
        this.closeAlertAccountComponent.close(activateAccount);
    }
}
